import { Typography } from '@mui/material'
import { Templates } from '@rjsf/mui'
import { BaseInputTemplateProps } from '@rjsf/utils'
import { useTranslation } from 'react-i18next'
import { dashify } from 'utils/dashify'

const { BaseInputTemplate } = Templates

export function RJSFBaseInputTemplate(props: BaseInputTemplateProps) {
  const { t } = useTranslation()

  const label =
    props.uiSchema['ui:title']?.toString() ||
    props.uiSchema['ui:label']?.toString()

  let translatedLabel = undefined

  if (label) {
    const translationKey = `ws-${
      props.uiSchema['ui:label-translation-key'] || dashify(label)
    }`

    translatedLabel = t(translationKey, { defaultValue: label, ns: 'project' })
  }

  const description = props.uiSchema['ui:description-translation-key']
    ? t(props.uiSchema['ui:description-translation-key'], {
        defaultValue: props.uiSchema['ui:description'],
        ns: 'project',
      })
    : props.uiSchema['ui:description']

  let validation = undefined

  if (props.uiSchema['min-value'] != null) {
    try {
      const valueNumber = Number(props.value ?? 0)
      if (isNaN(valueNumber)) {
        validation = 'should be a number'
      } else if (valueNumber <= props.uiSchema['min-value']) {
        validation = t('min-value', {
          minValue: props.uiSchema['min-value'],
          ns: 'common',
        })
      }
    } catch (err) {
      console.error('cant validate ' + props.value, err)
    }
  }

  if (props.uiSchema['max-value'] != null) {
    try {
      const valueNumber = Number(props.value ?? 0)

      if (isNaN(valueNumber)) {
        validation = 'should be a number'
      } else if (valueNumber > props.uiSchema['max-value']) {
        validation = validation = t('max-value', {
          maxValue: props.uiSchema['max-value'],
          ns: 'common',
        })
      }
    } catch (err) {
      console.error('cant validate ' + props.value, err)
    }
  }

  return (
    <>
      <BaseInputTemplate
        {...props}
        label={translatedLabel}
        // className={'ws__form__input'}
        onFocusCapture={(e: any) => e.target.select()}
        fullWidth
        size="small"
        sx={{
          '& input': {
            // padding: '.1em 0',
            // fontSize: '.75rem',
            minWidth: '3rem',
            padding: '2px 0 3px 0',
            fontSize: '12px',
          },
        }}
        error={Boolean(props.rawErrors?.length) || Boolean(validation)}
        helperText={
          <Typography variant="caption" whiteSpace={'normal'} component="span">
            {props.rawErrors?.join(' ') || validation || description}
          </Typography>
        }
      />
    </>
  )
}
